import { createSlice } from "@reduxjs/toolkit";
import { deleteJob, getJob, undoDeleteJob } from "./job.api";

const jobSlice = createSlice({
  name: "job",
  initialState: {
    job: [],
    loading: false,
    error: null,
    success: null,
    dataLimit: 0,
    currentPage: 0,
    totalPages: 0,
    totalData: 0,
  },
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = null;
    },
    updateLocalOrder: (state, action) => {
      state.job.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getJob.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getJob.fulfilled, (state, action) => {
      state.loading = false;
      state.job = action.payload;
      state.dataLimit = action.payload.meta.limit;
      state.currentPage = action.payload.meta.page;
      state.totalPages = action.payload.meta.totalPages;
      state.totalData = action.payload.meta.total;
    });
    builder.addCase(getJob.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(deleteJob.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteJob.fulfilled, (state, action) => {
      const deletedId = action.payload.data._id;

      if (state.job.data) {
        state.job.data = state.job.data.filter((job) => {
          return job._id !== deletedId;
        });
        state.loading = false;
      } else {
        console.error("state.job.data is not an array:", state.job.data);
      }
      state.loading = false;
    });
    builder.addCase(deleteJob.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(undoDeleteJob.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(undoDeleteJob.fulfilled, (state, action) => {
      const undodeletedId = action.payload.data._id;

      if (state.job.data) {
        state.job.data = state.job.data.filter((job) => {
          return job._id !== undodeletedId;
        });
        state.loading = false;
      } else {
        console.error("state.job.data is not an array:", state.job.data);
      }
      state.loading = false;
    });
    builder.addCase(undoDeleteJob.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { resetState } = jobSlice.actions;
export default jobSlice.reducer;
